// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Icon$Showside from "../icons/Icon.bs.js";
import * as IconPin$Showside from "../icons/IconPin.bs.js";
import * as IconTag$Showside from "../icons/IconTag.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as IconInfo$Showside from "../icons/IconInfo.bs.js";
import * as IconZoom$Showside from "../icons/IconZoom.bs.js";
import * as IconAlbum$Showside from "../icons/IconAlbum.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as IconChevronDown$Showside from "../icons/IconChevronDown.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
function QuickViewOverlayButton(Props) {
  var kind = Props.kind;
  var at = Props.at;
  var sizeOpt = Props.size;
  var colorOpt = Props.color;
  var text = Props.text;
  var textColor = Props.textColor;
  var backgroundColor = Props.backgroundColor;
  var iconLink = Props.iconLink;
  var margin = Props.margin;
  var openLinkInNewTab = Props.openLinkInNewTab;
  var style = Props.style;
  var canCollapseOpt = Props.canCollapse;
  var showTextOpt = Props.showText;
  var collapsedOpt = Props.collapsed;
  var isMobile = Props.isMobile;
  var containerClassNameOpt = Props.containerClassName;
  var onTouchMove = Props.onTouchMove;
  var onTouchEnd = Props.onTouchEnd;
  var onClick = Props.onClick;
  var size = sizeOpt !== undefined ? sizeOpt : /* Large */2;
  var color = colorOpt !== undefined ? colorOpt : /* Clear */2;
  var canCollapse = canCollapseOpt !== undefined ? canCollapseOpt : true;
  var showText = showTextOpt !== undefined ? showTextOpt : true;
  var collapsed = collapsedOpt !== undefined ? collapsedOpt : false;
  var containerClassName = containerClassNameOpt !== undefined ? containerClassNameOpt : "";
  var match = EntrypointContext$Showside.use(undefined);
  var redirectToLink = match.redirectToLink;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$1.goTo;
  var mediaNodeId = at ? at._0.id : undefined;
  var tmp;
  if (text !== undefined) {
    tmp = text;
  } else if (typeof kind === "number") {
    if (kind >= 3) {
      tmp = undefined;
    } else {
      switch (kind) {
        case /* Close */0:
          tmp = undefined;
          break;
        case /* ViewDetails */1:
          tmp = "View Details";
          break;
        case /* ViewProducts */2:
          tmp = "View Products";
          break;
      }
    }
  } else {
    tmp = "Learn More";
  }
  var alt = Belt_Option.getWithDefault(tmp, "");
  var iconSizeInPx;
  switch (size) {
    case /* Small */0:
      iconSizeInPx = 16;
      break;
    case /* Medium */1:
      iconSizeInPx = 18;
      break;
    case /* Large */2:
      iconSizeInPx = 24;
      break;
  }
  var icon;
  if (iconLink !== undefined) {
    icon = React.createElement(Icon$Showside.make, {
      className: Cn.make([CSS$Showside.prefix("absolute left-1/2 transform -translate-x-1/2"), "smartnav-quickview-button-icon"]),
      src: iconLink,
      alt: alt
    });
  } else if (typeof kind === "number") {
    switch (kind) {
      case /* Close */0:
        icon = React.createElement(IconChevronDown$Showside.make, {
          className: CSS$Showside.prefix(Cn.make(["w-full h-full", "-bottom-px relative"]))
        });
        break;
      case /* ViewDetails */1:
        icon = React.createElement(IconInfo$Showside.make, {
          className: CSS$Showside.prefix("w-full h-full")
        });
        break;
      case /* ViewProducts */2:
        icon = React.createElement(IconTag$Showside.make, {
          className: CSS$Showside.prefix(Cn.make(["w-full h-full", "-bottom-px left-px relative"]))
        });
        break;
      case /* ViewZoom */3:
        icon = React.createElement(IconZoom$Showside.make, {
          className: CSS$Showside.prefix("w-full h-full")
        });
        break;
      case /* ViewAlbum */4:
        icon = React.createElement(IconAlbum$Showside.make, {
          className: CSS$Showside.prefix("w-full h-full")
        });
        break;
      case /* Hidden */5:
        icon = null;
        break;
      case /* Pin */6:
        icon = React.createElement(IconPin$Showside.make, {
          className: CSS$Showside.prefix(Cn.make(["w-full h-full", "-top-px relative"]))
        });
        break;
    }
  } else {
    icon = React.createElement(Unicons$Showside.UilLinkAlt.make, {
      size: /* Px */{
        _0: iconSizeInPx
      },
      className: CSS$Showside.prefix("w-full h-full")
    });
  }
  var text$1;
  if (showText) {
    if (text !== undefined) {
      text$1 = text;
    } else if (typeof kind === "number") {
      if (kind >= 3) {
        text$1 = undefined;
      } else {
        switch (kind) {
          case /* Close */0:
            text$1 = undefined;
            break;
          case /* ViewDetails */1:
            text$1 = "View Details";
            break;
          case /* ViewProducts */2:
            text$1 = "View Products";
            break;
        }
      }
    } else {
      text$1 = "Learn More";
    }
  } else {
    text$1 = undefined;
  }
  var ref = React.useRef(null);
  var dataTestId = at ? typeof kind === "number" ? kind !== 0 ? kind >= 6 ? "qv-pinned-media-button" : "qv-expand-panel-button" : "qv-collapse-panel-button" : "qv-expand-panel-button" : typeof kind === "number" ? kind !== 0 ? kind >= 6 ? "qv-pinned-media-button" : "qv-expand-media-button" : "qv-collapse-media-button" : "qv-expand-media-button";
  var link = typeof kind === "number" ? undefined : kind._0;
  var collapsed$1 = collapsed || Belt_Option.isNone(text$1) || isMobile && at === /* Card */0;
  var collapsed$2 = canCollapse && collapsed$1;
  var renderBaseButton = function (className, icon, text, param) {
    var containerClassName$1 = Cn.make([at ? CSS$Showside.prefix("relative") : CSS$Showside.prefix("absolute bottom-0 flex flex-start pointer-events-none"), canCollapse && showText ? CSS$Showside.prefix("w-full") : "", kind === /* Hidden */5 ? CSS$Showside.prefix("opacity-0") : "", containerClassName]);
    var buttonClassName = Cn.make([className, CSS$Showside.prefix("flex items-center rounded-full whitespace-nowrap rounded-full pointer-events-auto text-base transiton-all duration-300"), kind === /* Hidden */5 ? "" : CSS$Showside.prefix("pointer-events-auto"), collapsed$2 ? CSS$Showside.prefix("max-w-0p") : CSS$Showside.prefix("max-w-full")]);
    var textClassName = CSS$Showside.prefix(Cn.make(["overflow-hidden transition-all duration-300", collapsed$2 ? "opacity-0" : "opacity-100"]));
    var iconClassName = CSS$Showside.prefix("flex-shrink-0");
    var tmp = {};
    if (margin !== undefined) {
      tmp.padding = margin;
    }
    var containerStyle = tmp;
    var tmp$1 = {};
    if (backgroundColor !== undefined) {
      tmp$1.backgroundColor = backgroundColor;
    }
    if (textColor !== undefined) {
      tmp$1.color = textColor;
    }
    var buttonStyle = tmp$1;
    var buttonStyle$1 = Belt_Option.mapWithDefault(style, buttonStyle, function (styleProp) {
      return Object.assign({}, styleProp, buttonStyle);
    });
    var onClick$1 = function (e) {
      if (link === undefined) {
        if (typeof kind === "number") {
          e.preventDefault();
          return Curry._1(onClick, undefined);
        } else {
          e.stopPropagation();
          return;
        }
      }
      switch (link.TAG | 0) {
        case /* URL */0:
          return Curry._5(redirectToLink, undefined, undefined, undefined, openLinkInNewTab, link._0);
        case /* Category */1:
          var match = link._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* ListPage */1,
            _0: {
              listPageType: {
                TAG: /* Category */0,
                _0: match.categoryId
              },
              viewPLP: false,
              filters: match.filters,
              sort: undefined
            }
          });
        case /* Product */2:
          var match$1 = link._0;
          var productCategoryId = match$1.productCategoryId;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* PDP */2,
            _0: {
              categoryId: productCategoryId,
              productCategoryId: productCategoryId,
              productId: match$1.productId,
              variantId: match$1.variantId,
              zoomedPhotoIndex: undefined
            }
          });
        case /* StoreCategory */3:
          var match$2 = link._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* ListPage */1,
            _0: {
              listPageType: {
                TAG: /* StoreCategory */2,
                _0: {
                  categoryId: match$2.categoryId,
                  sourceNodeId: mediaNodeId
                }
              },
              viewPLP: false,
              filters: undefined,
              sort: match$2.sortBy
            }
          });
        case /* CustomAction */4:
          var match$3 = link._0;
          CustomScript$Showside.triggerCustomFunctionWithoutProducts(match$3.code, match$3.name, undefined, undefined);
          return;
      }
    };
    var tmp$2 = {
      color: color,
      className: buttonClassName,
      onClick: onClick$1,
      children: null,
      flex: true,
      style: buttonStyle$1,
      hasText: true,
      dataTestId: dataTestId
    };
    if (onTouchMove !== undefined) {
      tmp$2.onTouchMove = Caml_option.valFromOption(onTouchMove);
    }
    if (onTouchEnd !== undefined) {
      tmp$2.onTouchEnd = Caml_option.valFromOption(onTouchEnd);
    }
    if (openLinkInNewTab !== undefined) {
      tmp$2.openLinkInNewTab = Caml_option.valFromOption(openLinkInNewTab);
    }
    return React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(ref),
      className: containerClassName$1,
      style: containerStyle
    }, React.createElement(QuickViewButton$Showside.make, tmp$2, React.createElement("div", {
      className: iconClassName
    }, icon), React.createElement("div", {
      className: textClassName
    }, text)));
  };
  switch (size) {
    case /* Small */0:
      var icon$1 = React.createElement("div", {
        className: CSS$Showside.prefix("w-5.5 h-5.5")
      }, icon);
      var text$2 = Belt_Option.mapWithDefault(text$1, null, function (text) {
        return React.createElement("div", {
          className: CSS$Showside.prefix("px-2")
        }, text);
      });
      var className = CSS$Showside.prefix("p-1.5 min-w-8");
      return renderBaseButton(className, icon$1, text$2, undefined);
    case /* Medium */1:
      var icon$2 = React.createElement("div", {
        className: CSS$Showside.prefix("w-6 h-6")
      }, icon);
      var text$3 = Belt_Option.mapWithDefault(text$1, null, function (text) {
        return React.createElement("div", {
          className: CSS$Showside.prefix("text-base pl-3 pr-1")
        }, text);
      });
      var className$1 = CSS$Showside.prefix("p-2 min-w-10");
      return renderBaseButton(className$1, icon$2, text$3, undefined);
    case /* Large */2:
      var icon$3 = color >= 2 ? React.createElement("div", {
        className: CSS$Showside.prefix("w-8 h-8")
      }, icon) : React.createElement("div", {
        className: CSS$Showside.prefix("flex items-center justify-center w-8 h-8")
      }, React.createElement("div", {
        className: CSS$Showside.prefix("w-6 h-6")
      }, icon));
      var text$4 = Belt_Option.mapWithDefault(text$1, null, function (text) {
        return React.createElement("div", {
          className: CSS$Showside.prefix("text-lg pl-3 pr-1.5")
        }, text);
      });
      var className$2 = CSS$Showside.prefix("p-2.5 min-w-13");
      return renderBaseButton(className$2, icon$3, text$4, undefined);
  }
}
QuickViewOverlayButton.displayName = "QuickViewOverlayButton";
var make = QuickViewOverlayButton;
export { make };
/* react Not a pure module */